export default function (instance) {
  return {
    plan_faculty() {
      return instance.post("plan_faculty", {});
    },
    plan_direction(payload) {
      return instance.post("plan_direction", {
        id_faculty: payload.id_faculty,
      });
    },
    plan_speciality(payload) {
      return instance.post("plan_speciality", {
        id_direction: payload.id_direction,
      });
    },
    plan_f_o(payload) {
      return instance.post("plan_f_o", {
        id_spes: payload.id_spes,
        id_type_o: payload.id_type_o,
      });
    },
    plan_type_o(payload) {
      return instance.post("plan_type_o", { id_spes: payload.id_spes });
    },
    add_plan(payload) {
      return instance.post("administrator/add_plan", {
        id_faculty: payload.id_faculty,
        id_direction: payload.id_direction,
        id_spes: payload.id_spes,
        id_type_o: payload.id_type_o,
        id_f_o: payload.id_f_o,
        plan: payload.plan,
        note: payload.note,
      });
    },
    get_plan() {
      return instance.post("administrator/get_plan", {});
    },
    delete_plan(payload) {
      return instance.post("administrator/delete_plan", {
        id: payload.id,
      });
    },
  };
}
